import React, { Component } from "react";
import { Map, TileLayer } from "react-leaflet";
import L from "leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-geosearch/dist/geosearch.css";
import "leaflet-draw";

// Fix default Leaflet marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

class MapPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presensi_geolocation: (props.defaultPolygon && props.defaultPolygon.length > 2)
        ? props.defaultPolygon
        : null,
      center: (props.defaultPolygon && props.defaultPolygon.length > 2)
        ? this.getPolygonCenter(props.defaultPolygon)
        : [-6.914744, 107.60981]
    };
    // this.state = {
    //   presensi_geolocation: props.defaultPolygon || null,
    //   center: props.defaultPolygon
    //     ? this.getPolygonCenter(props.defaultPolygon)
    //     : [-6.914744, 107.60981], // default Bandung
    // };
  }

  componentDidMount() {
    const { mode = "edit" } = this.props;
    const map = this.map.leafletElement;

    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

      // ✅ Selalu buat polygon jika ada default polygon
    if (this.state.presensi_geolocation) {
      const polygon = L.polygon(this.state.presensi_geolocation, {
        color: "#007bff",
      });
      polygon.addTo(drawnItems);
      map.fitBounds(polygon.getBounds());

      if (this.props.onPolygonChange) {
        this.props.onPolygonChange(this.state.presensi_geolocation);
      }
    }


    // === VIEW MODE ===
    if (mode === "view") {
      map.dragging.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollWheelZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      if (map.tap) map.tap.disable();
      map._container.style.cursor = "default";
      return;
    }

    // === EDIT MODE ===
   

    const drawControl = new L.Control.Draw({
      draw: {
        polygon: {
          allowIntersection: false,
          showArea: true,
          drawError: {
            color: "#b00b00",
            message: "Polygon tidak boleh bersilangan!",
          },
          shapeOptions: {
            color: "#007bff",
            weight: 2,
          },
        },
        marker: false,
        circle: false,
        rectangle: false,
        circlemarker: false,
        polyline: false,
      },
      edit: {
        featureGroup: drawnItems,
        remove: true,
      },
    });
    map.addControl(drawControl);

    // Jika ada polygon default dari props
    if (this.state.presensi_geolocation) {
      const polygon = L.polygon(this.state.presensi_geolocation, {
        color: "#007bff",
      });
      polygon.addTo(drawnItems);
      if (this.props.onPolygonChange) {
        this.props.onPolygonChange(this.state.presensi_geolocation);
      }
      map.fitBounds(polygon.getBounds());
    }

    // Event buat polygon baru
    map.on(L.Draw.Event.CREATED, (e) => {
      const layer = e.layer;
      drawnItems.clearLayers();
      drawnItems.addLayer(layer);
      console.log('layer ini mah ')
      console.log(layer)
      const latlngs = layer.getLatLngs()[0].map((p) => [p.lat, p.lng]);
      this.setState({ presensi_geolocation: latlngs });
      console.log('===============createed=============')
      console.log(latlngs)

      if (this.props.onPolygonChange) {
        this.props.onPolygonChange(latlngs);
      }
    });

    // Event edit polygon
    map.on(L.Draw.Event.EDITED, () => {
      drawnItems.eachLayer((layer) => {
        const latlngs = layer.getLatLngs()[0].map((p) => [p.lat, p.lng]);
        this.setState({ presensi_geolocation: latlngs });
        if (this.props.onPolygonChange) {
          this.props.onPolygonChange(latlngs);
        }
      });
    });

    // Event hapus polygon
    map.on(L.Draw.Event.DELETED, () => {
      this.setState({ presensi_geolocation: null });
      if (this.props.onPolygonChange) {
        this.props.onPolygonChange(null);
      }
    });

    /*
     * ✅ GEOSEARCH
     */
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider,
      style: "bar",
      showMarker: false, // ✅ ga pake marker
      autoClose: true,
      retainZoomLevel: false,
      searchLabel: "Cari lokasi…",
    });

    map.addControl(searchControl);

    // ✅ Ketika hasil search dipilih → langsung pindah map
    map.on("geosearch/showlocation", (event) => {
      const { x, y } = event.location;
      map.setView([y, x], 16);

      // if (this.props.onLocationSelect) {
      //   this.props.onLocationSelect({
      //     lat: y,
      //     lng: x,
      //     address: event.location.label,
      //   });
      // }
    });
  }

  getPolygonCenter = (coords) => {
    const latSum = coords.reduce((acc, c) => acc + c[0], 0);
    const lngSum = coords.reduce((acc, c) => acc + c[1], 0);
    return [latSum / coords.length, lngSum / coords.length];
  };

  render() {
    const { center } = this.state;

    return (
      <Map
        center={center}
        zoom={13}
        style={{ height: "400px", width: "100%" }}
        ref={(m) => {
          this.map = m;
        }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </Map>
    );
  }
}

export default MapPicker;
